var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxCheck = function SvgCheckboxCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checkbox-a",
    d: "M10.289 1.697a1 1 0 1 1 1.422 1.406l-7.148 7.23a1 1 0 0 1-1.421 0L.29 7.453a1 1 0 0 1 1.42-1.407l2.142 2.162 6.437-6.511z"
  }))));
};
export default SvgCheckboxCheck;